'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A component that renders nothing visible, but is helpful when you need
 * to trigger render() on all children without any visible display
 *
 * This is primarily used in jQuery wrappers that simply convert a component
 * tree into a javascript config object or something other than DOM
 */
var Empty = function Empty(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'noscript',
    null,
    children
  );
};
exports.default = Empty;


Empty.propTypes = {
  children: _react2.default.PropTypes.node
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.33/js/components/Empty.js
// module id = 327
// module chunks = 0 1